export default "__VITE_ASSET__D1EC0zgs__"